import { createClient } from '@supabase/supabase-js';
import { storageAdapter } from './storageAdapter';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from './constants';

const isElectron = typeof window !== 'undefined' && window.electronAPI;
export const supabaseClient = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: !isElectron,
    flowType: isElectron ? 'implicit' : 'pkce',
    storage: storageAdapter,
  },
});

if (typeof window !== 'undefined' && window.auth && typeof window.auth.onOAuthComplete === 'function') {
  window.auth.onOAuthComplete(async () => {
    try {
      const raw = await window.auth.storage.getItem('sb:session');
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (parsed && parsed.access_token && parsed.refresh_token) {
        await supabaseClient.auth.setSession({
          access_token: parsed.access_token,
          refresh_token: parsed.refresh_token,
        });
      }
    } catch (e) {
    }
  });
}

if (typeof window !== 'undefined' && window.auth && window.auth.storage) {
  (async () => {
    try {
      const raw = await window.auth.storage.getItem('sb:session');
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (parsed && parsed.access_token && parsed.refresh_token) {
        await supabaseClient.auth.setSession({
          access_token: parsed.access_token,
          refresh_token: parsed.refresh_token,
        });
      }
    } catch (_e) {
    }
  })();
}

if (typeof window !== 'undefined' && window.auth && typeof window.auth.onOAuthCode === 'function') {
  window.auth.onOAuthCode(async (code) => {
    try {
      if (typeof supabaseClient.auth.exchangeCodeForSession === 'function') {
        await supabaseClient.auth.exchangeCodeForSession(code);
      }
    } catch (_e) {
    }
  });
}


